import _ from 'lodash'
import Backbone from 'backbone'

var scoringTypesById, scoringTypesByStandardType, thresholdsById

var config = {

	/**
	 * @returns {ScoringType[]}
	 */
	get scoringTypes() {
		return this._scoringTypes
	},

	/**
	 * @param {ScoringType[]} scoringTypes
	 */
	set scoringTypes(scoringTypes) {
		this._scoringTypes = scoringTypes
		scoringTypesById = null
		scoringTypesByStandardType = null
		thresholdsById = null
	},

	/**
	 * Returns the scoring type for the given ID or standard scoring type
	 * @param {Number|String} handle a scoring type ID or a standard scoring
	 * type
	 * @return {ScoringType}
	 */
	scoringType: function(handle) {
		if (!scoringTypesById) {
			scoringTypesById = _.keyBy(this.scoringTypes, 'id')
			scoringTypesByStandardType = _(this.scoringTypes)
				.filter(st => !_.isNil(st.standardScoringType))
				.keyBy('standardScoringType')
				.value()
		}
		return scoringTypesById[handle] || scoringTypesByStandardType[handle]
	},

	/**
	 * @return {ScoringThreshold}
	 */
	threshold: function(id) {
		if (!thresholdsById) {
			thresholdsById = _(this.scoringTypes)
				.map('thresholds')
				.flatten()
				.keyBy('id')
				.value()
		}
		return thresholdsById[id]
	},

	/**
	 * Returns true if the given scorecard item has a custom text scoring type
	 * @param {Object} scorecard item
	 * @return {boolean}
	 */
	customTextScoringType: function(item) {
		let scoringType = this.scorecardItemScoringType(item)
		return _.get(scoringType, 'isCustomText', false)
	},

	/**
	 * Returns the scoring type for the given scorecard item
	 * @param {Object} scorecard item
	 * @return {ScoringType}
	 */
	scorecardItemScoringType: function(item) {
		let scoringTypeId = _.get(item, 'scoringTypeId')
		return this.scoringType(scoringTypeId)
	},

	update: function(configData) {
		_.extend(config, configData)
	},

	/**
	 * There is a RuntimeConfiguration class that exposes MBean operations to affect
	 * how the client looks.  This allows testers to validate the production view
	 * while still running all of the backend services against the QA environment(s)
	 */
	isProductionUI: function() {
		return config.production || config.emulateProductionUI
	}
}

// we have to do this because config is injected into places it's
// required before it's actually been loaded
Backbone.on('load', function(loginData) {
	if (loginData.config) {
		config.update(loginData.config)
	}
})

export default config

config.__filename__ = 'components/config.js'
